// This is the action button element name, useful to modify the button styles with @twilio-paste/core/styling-library.
export const ACTION_BTN = "ACTION_BTN";

export const defaultDisabledState = {
  isHomeButtonDisabled: false,
  isViewTicketButtonDisabled: false,
  isProvideFeedbackButtonDisabled: false,
};
